import React from 'react'
import {translate} from 'react-i18next'
import {LANGUAGES_NAME} from 'const'

import {createOrUpdateQueryParam} from 'utils/stringUtils'

const LanguageList = ({i18n, show = true, languageOptions}) => {
  const changeLanguage = lang => async () => {
    await i18n.changeLanguage(lang)
    createOrUpdateQueryParam('lang', lang)
  }

  return show ? (
    <ul>
      {languageOptions.map(lang => (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
        <li key={lang} className={i18n.language === lang ? 'selected' : undefined} onClick={changeLanguage(lang)}>
          {LANGUAGES_NAME[lang]}
        </li>
      ))}
    </ul>
  ) : null
}

export default translate()(LanguageList)
